import React from "react";
import { useNavigate } from "react-router-dom";

function BankTransfer({ setShowWallet, virtualAccountNumber }) {
  const navigate = useNavigate();
  return (
    <div className="slide-in" style={{ width: "100%", padding: "0rem" }}>
      <span
        className="flex align-center cercle-purple-text hover pointer "
        onClick={() => setShowWallet(true)}
      >
        Back
      </span>
      <div className="valign-wrapper column  justify-center">
        <h5 className="margin-0px">Account Details</h5>
        <p className="small-text">You can transfer money to this account.</p>
      </div>
      <div className="full-width mt-1">
        <span className="flex column gap-10px">
          <p className="font-18px">
            Account number : <span>{virtualAccountNumber || "..."}</span>
          </p>
          <p className="font-18px">
            IFSC Code : <span>ICIC0000106</span>
          </p>
          <p className="font-18px">
            Account holder name : <span>Infinite Cercle Private Limited</span>
          </p>
        </span>
      </div>
      <div className="valign-wrapper justify-center mt-2">
        <b
          className="font-14px text-decoration-underLine pointer cercle-purple-text"
          onClick={() => navigate("/payment/help-instruction")}
        >
          Step-by-Step Payment Help.
        </b>
      </div>
    </div>
  );
}

export default BankTransfer;
